/**
 * Saved parts for Chip-seek.
 *
 * - List rows expose a bookmark button backed by localStorage.
 * - The Saved Parts page reads localStorage, refreshes each record from the
 *   product JSON endpoint, and renders cards with current data when available.
 * - Storage is browser-local. Nothing is sent to the server.
 */
(function () {
  const STORAGE_KEY = "ics_saved_parts";
  const MAX_SAVED = 50;

  function readSaved() {
    try {
      const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function writeSaved(parts) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(parts));
    } catch (error) {
      // Storage may be unavailable (private mode or quota). UI stays non-destructive.
    }
  }

  function findSaved(handle) {
    return readSaved().find(function (part) {
      return part.handle === handle;
    });
  }

  function addPart(button) {
    const parts = readSaved();
    const handle = button.dataset.saveHandle;
    if (!handle || findSaved(handle)) return;

    parts.unshift({
      handle: handle,
      title: button.dataset.saveTitle || "",
      vendor: button.dataset.saveVendor || "",
      url: button.dataset.saveUrl || "/products/" + handle,
      image: button.dataset.saveImage || "",
      price: button.dataset.savePrice || "",
      savedAt: new Date().toISOString(),
    });
    writeSaved(parts.slice(0, MAX_SAVED));
    syncButton(button, true);
    publishSavedCount();
  }

  function removePart(handle) {
    const parts = readSaved().filter(function (part) {
      return part.handle !== handle;
    });
    writeSaved(parts);
    document.querySelectorAll("[data-save-handle]").forEach(function (btn) {
      if (btn.dataset.saveHandle === handle) {
        syncButton(btn, false);
      }
    });
    publishSavedCount();
  }

  function clearAll() {
    writeSaved([]);
    document.querySelectorAll("[data-save-handle]").forEach(function (btn) {
      syncButton(btn, false);
    });
    publishSavedCount();
  }

  function syncButton(button, saved) {
    if (!button) return;
    button.setAttribute("aria-pressed", saved ? "true" : "false");
    button.classList.toggle("is-saved", saved);
    button.setAttribute("title", saved ? "Remove from saved parts" : "Save this part");
    const label = button.querySelector(".visually-hidden");
    if (label) {
      label.textContent = saved
        ? "Remove from saved parts"
        : "Save " + (button.dataset.saveTitle || "this part");
    }
  }

  function publishSavedCount() {
    const count = readSaved().length;
    document.querySelectorAll("[data-saved-count]").forEach(function (el) {
      el.textContent = String(count);
    });
    document.dispatchEvent(
      new CustomEvent("ics:saved-parts:changed", { detail: { count: count } }),
    );
  }

  document.addEventListener("click", function (event) {
    const button = event.target.closest("[data-save-handle]");
    if (!button || !button.matches("button.ics-save-button")) return;

    event.preventDefault();
    const handle = button.dataset.saveHandle;
    if (button.getAttribute("aria-pressed") === "true") {
      removePart(handle);
    } else {
      addPart(button);
    }
  });

  function initializeButtons() {
    const saved = readSaved();
    const savedHandles = new Set(saved.map(function (part) { return part.handle; }));
    document.querySelectorAll("[data-save-handle]").forEach(function (button) {
      syncButton(button, savedHandles.has(button.dataset.saveHandle));
    });
    publishSavedCount();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeButtons);
  } else {
    initializeButtons();
  }

  window.icsSavedParts = {
    read: readSaved,
    remove: removePart,
    clear: clearAll,
  };
})();
